import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@firebird-web/shared-config';
import { apiEndpoints } from '@firebird-web/shared-constants';

@Injectable({
  providedIn: 'root',
})
export class DownloadService {
  constructor(private readonly http: HttpClient) {}

  public downloadApiDocumentation(): Observable<string> {
    return this.http.get<string>(
      `${environment.apiDomain}/${apiEndpoints.getAPIDocumentation}`
    );
  }
}
